import { convertUTCTimeToLocal } from "../Utils";
import { FormatDate } from "../../api-client-nswag/taxportal-client";

const CellRenderDate = (date: string, format: string = FormatDate.AC) => {
  // convertUTCTimeToLocal only guards against a strict null; empty/undefined values must be filtered here to avoid "Invalid date"
  if (!date) {
    return <div></div>;
  }
  return <div>{convertUTCTimeToLocal(date, format)}</div>;
};

export default CellRenderDate;
